<template>
  <div>
    <el-dialog
      title="咨询表单"
      :visible.sync="visible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      width="840px"
      class="million-face-dialog">
      <div class="dialog-info">如有合作意向或产品问题，可预留联系方式或添加官方QQ629133609</div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm">
        <el-form-item label="联系人" prop="name">
          <el-input v-model="ruleForm.name" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="phone">
          <el-input v-model="ruleForm.phone" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="ruleForm.email" maxlength="500"></el-input>
        </el-form-item>
        <el-form-item label="人脸库预期大小" prop="size">
          <el-radio-group v-model="ruleForm.size">
            <el-radio label="小于50w">小于50w</el-radio>
            <el-radio label="50w-100w">50w-100w</el-radio>
            <el-radio label="大于100w">大于100w</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="行业" prop="industry">
          <el-input v-model="ruleForm.industry" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="请描述您的应用场景和技术能力要求" prop="describe">
          <el-input type="textarea" v-model="ruleForm.describe" maxlength="1000" placeholder="在安防场景下，做黑名单比对，达到实时预警的效果，对人脸库大小的要求大概在120w量级……"></el-input>
        </el-form-item>
        <el-form-item label="企业名称" prop="company">
          <el-input v-model="ruleForm.company" maxlength="200"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm()">确 定</el-button>
        <el-button @click="visible=false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/common/api';

export default {
  props: {
    dialogVisible: Boolean
  },
  data() {
    return {
      visible: this.dialogVisible,
      ruleForm: {
        name: '',
        phone: '',
        email: '',
        company: '',
        size: '',
        industry: '',
        describe: ''
      },
      rules: {
        name: [
          { required: true, validator: this.validateName, trigger: ['blur', 'change'] },
          { min: 1, max: 20, message: '联系人长度不能超过20字符', trigger: ['blur', 'change'] }
        ],
        phone: [
          { required: true, validator: this.validatePhone, trigger: ['blur', 'change'] }
        ],
        email: [
          { required: true, validator: this.validateMail, trigger: ['blur', 'change'] }
        ],
        size: [
          { required: true, message: '请选择人脸库大小', trigger: 'change' }
        ],
        industry: [
          { required: true, validator: this.validateIndustry, trigger: ['blur', 'change'] },
          { min: 1, max: 100, message: '行业长度不能超过100字符', trigger: ['blur', 'change'] }
        ],
        describe: [
          { required: true, validator: this.validateDescribe, trigger: ['blur', 'change'] },
          { min: 1, max: 1000, message: '应用场景和技术能力要求长度不能超过1000字符', trigger: ['blur', 'change'] }
        ]
      }
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (this.$refs.ruleForm) {
          this.$refs.ruleForm.resetFields();
        }
        this.$emit('update:dialogVisible', val);
      }
    },
    dialogVisible: {
      immediate: true,
      handler(val) {
        this.visible = val;
      }
    }
  },
  methods: {
    validateName(rule, value, callback) {
      if (value.trim() === '') {
        return callback(new Error('请输入联系人'));
      }
      callback();
    },
    validateIndustry(rule, value, callback) {
      if (value.trim() === '') {
        return callback(new Error('请输入行业'));
      }
      callback();
    },
    validateDescribe(rule, value, callback) {
      if (value.trim() === '') {
        return callback(new Error('请描述应用场景和技术能力要求'));
      }
      callback();
    },
    validatePhone(rule, value, callback) {
      if (value.trim() === '') {
        return callback(new Error('请输入11位手机号码'));
      }
      if (value.trim().length !== 11 || !(/^1[3456789]\d{9}$/.test(value))) {
        return callback(new Error('手机号码格式错误，请重新输入'));
      }
      callback();
    },
    validateMail(rule, value, callback) {
      if (value.trim() === '') {
        return callback(new Error('请输入邮箱'));
      }
      if (!(/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(value))) {
        return callback(new Error('邮箱格式错误，请重新填写'));
      }
      if (value.trim().indexOf(';') !== -1) {
        return callback(new Error('仅需提供单人邮箱地址'));
      }
      callback();
    },
    submitForm() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          const loading = this.loading();
          this.$loader.upload(api.face.MILLION_RETRIEVAL, this.ruleForm, null, null).then(() => {
            this.$emit('close');
            loading.close();
          }).finally(() => {
            loading.close();
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
@import "../../../styles/form.less";
.million-face-dialog {
  z-index: 10 !important;
  background: rgba(0, 0, 0, 0.5);
  + .v-modal {
    display: none;
  }
  .el-dialog{
    box-shadow: 1px 1px 16px 0px rgba(0, 0, 0, 0.16);
    border-radius: 8px;
    .el-dialog__header{
      padding-top: 40px;
      padding-bottom: 10px;
      text-align: center;
      .el-dialog__title{
        font-size: 24px;
        color:#333333;
      }
      .el-dialog__headerbtn .el-dialog__close{
        color:#999999;
      }
      .el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close{
        color:#5c9dff;
      }
    }
    .el-dialog__body{
      padding: 0px 75px 20px 75px;
      .dialog-info {
        text-align: center;
        padding-bottom: 40px;
      }
      .el-form-item {
        margin-bottom: 30px;
        .el-form-item__label {
          width: 130px;
        }
        .el-form-item__content {
          width: 450px;
        }
        .el-textarea__inner{
          height: 190px;
          resize: none;
          font-family: inherit;
        }
      }
    }
    .el-dialog__footer{
      padding: 0px 165px 50px;
      .dialog-footer {
        width: 430px;
        .el-button{
          border-radius: 5px;
          width: 170px;
          &.el-button--primary{
            background: #5c9dff;
            &:hover{
              background: #3385ff;
            }
          }
          &.el-button--default{
            background: #ffffff;
            border: #5c9dff 1px solid;
            color: #5c9dff;
            &:hover{
              background: #ffffff;
              border: #3385ff 1px solid;
              color: #3385ff;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/open/common/ApplyMillion.vue